<div
  *ngIf="(editModeCheck$ | async) !== task.id; else editTaskForm"
  class="task-item-container"
  [class.side-drawer]="sideDrawerConfiguration"
>
  <div class="top align-flex width-100">

    <div class="display-flex">
      <mat-icon
        class="complete-icon"
        (click)="completeTask(fromDashboard)"
        [ngClass]="{'done': isCompleted}"
      >
        {{isCompleted ? 'done' : 'radio_button_unchecked'}}
      </mat-icon>
      <div class="task-item-center">
        <mojo-mentions-text-converter
          [textToConvert]="task.description"
          [fromTask]="true"
          [ngClass]="{'mentions': !sideDrawerConfiguration}"
          class="margin-left-3"
        >
        </mojo-mentions-text-converter>

      </div>
    </div>

    <mat-icon
      (click)="$event.stopPropagation()"
      [matMenuTriggerFor]="menu"
      class="three-dots-icon"
    >more_horiz</mat-icon>
  </div>

  <div class="center-zone align-flex">
    <div class="task-description-footer">
      <div class="display-flex flex-direction-column ">
        <div
          class="display-flex flex-items-end container-calendar"
          [ngClass]="{'overdue': getDate(task.dueDate) < today}"
        >
          <mat-icon class="calendar-icon">event</mat-icon>
          <span
            class="margin-left-4">{{getDate(task.dueDate) | date:'MM/dd/yy'}}</span>
        </div>

        <div
          class="display-flex margin-t-6"
          *ngIf="task?.entityType && task?.entityName && fromDashboard"
        >
          <ng-container [ngSwitch]="task?.entityType">

            <span
              *ngSwitchCase="'JOB'"
              class="material-icons-outlined"
            >work_outline</span>

            <span
              *ngSwitchCase="'TALENT_POOL'"
              class="material-icons-outlined"
            >folder_shared</span>

            <ng-container *ngIf="isValidEntityName(task)">
              <span
                *ngSwitchCase="'CANDIDATE'"
                class="material-icons-outlined"
              >
                person
              </span>
            </ng-container>

          </ng-container>

          <span
            *ngIf="isValidEntityName(task)"
            (click)="navigateAssign(task?.entityType, task?.entityId)"
            [matTooltip]="task?.entityName"
            [matTooltipDisabled]="(task?.entityName.length <= maxLength)"
            class="task-creator margin-left-4"
          >{{getEntityName(task)}}</span>
        </div>
      </div>
    </div>

    <div
      class="display-flex"
      [ngClass]="{'flex-items-end': fromDashboard}"
    >
      <common-mojo-avatar
        *ngIf="task?.assignedUserId"
        [ngClass]="{'margin-r': task?.assignedUser}"
        class="assignee"
        [id]="task?.assignedUserPhotoId"
        [matTooltip]="'Assignee: ' + task?.assignedUser"
        [backgroundSize]="avatarBackground"
        [initials]="getInitialsName(task?.assignedUser)"
        [selectedPhotoShape]="avatarPhotoShape"
      ></common-mojo-avatar>
      <common-mojo-avatar
        *ngIf="task?.creator"
        class="owner"
        [id]="task?.creatorPhotoId"
        [matTooltip]="'Owner: ' + task?.creator"
        [backgroundSize]="avatarBackground"
        [initials]="getInitialsName(task?.creator)"
        [selectedPhotoShape]="avatarPhotoShape"
      ></common-mojo-avatar>
    </div>
  </div>
</div>

<ng-template #editTaskForm>
  <mojo-edit-task-item
    [task]="task"
    [hasAnonymization]="hasAnonymization$ | async"
    [isDashboard]="fromDashboard"
  ></mojo-edit-task-item>
</ng-template>

<mat-menu #menu="matMenu">
  <button
    (click)="editTask()"
    mat-menu-item
    data-cy="edit-button"
  >Edit</button>
  <button
    (click)="removeTask(fromDashboard)"
    mat-menu-item
    data-cy="remove-button"
  >Remove</button>
</mat-menu>
